<template>
    <div class="navigation">
        <div class="container">
            <div class="navigation-content">
                <div class="nav-logo">
                    <a :href="$store.state.hrefPrefix + '/'">
                        <img v-if="$store.state.language.code === 'ar'"
                             src="/assets/images/the-cradle-arabic-nav-logo.png" style=" height: 43px" alt=""/>
                        <img v-else-if="$store.state.language.code === 'en'"
                             src="/assets/images/the-cradle-nav-logo.svg" alt=""/>
                        <img v-else-if="$store.state.language.code === 'tr'"
                             src="/assets/images/the-cradle-turkish-nav-logo.svg" style="height: 28px" alt=""/>
                    </a>
                </div>

                <ul class="primary-navigation">
                    <li><a :class="{'active': activeTab === 'Home'}" :href="$store.state.hrefPrefix + '/'">{{
                            $t('home')
                        }}</a></li>

                    <template v-for="category in topBarCategories">
                        <li v-if="!($store.state.language.code === 'tr' && category.slug === 'the-war-front')">
                            <a :class="{'active': activeTab === category.slug}"
                               :href="$store.state.hrefPrefix + '/category/' + category.slug">
                                {{ category.category_languages[0].pivot.name }}
                            </a>
                        </li>
                    </template>

                    <li v-if="$store.state.language.code === 'ar'"><a
                        :class="{'active': activeTab === 'report'}" :href="$store.state.hrefPrefix + '/category/report'">{{
                            $t('report_category')
                        }}</a></li>

                    <li v-if="$store.state.language.code !== 'ar'"><a
                        :class="{'active': activeTab === 'podcast'}" :href="$store.state.hrefPrefix + '/podcast'">{{
                            $t('podcast')
                        }}</a></li>

                    <li class="sub-menu">
                        <a :href="$store.state.hrefPrefix + '/columns'"
                           :class="{'active': activeTab === 'Columns'}">{{ $t('columns') }}</a>
                        <ul class="sub-menu-click">
                            <li v-for="column in columns"><a
                                :href="$store.state.hrefPrefix + '/columns/' + column.slug" title="columns">
                                {{ column.author_languages[0].pivot.name }}</a>
                            </li>
                        </ul>
                    </li>
                    <li v-if="$store.state.language.code !== 'tr'" class="support-btn">
                        <button>{{ $t('support_us') }}</button>
                    </li>
                </ul>

                <div class="header-search">
                    <a :href="$store.state.hrefPrefix + '/search'" class="search-click"><img
                        src="/assets/images/search-icon.svg" alt=""/> <span class="header-search-text"
                                                                            style="font-size: 18px; color: rgb(25, 25, 25)">{{
                            $t('search')
                        }}</span></a>
                    <!--                    <div class="translate-click">-->
                    <!--                        <span id=":0.targetLanguage" class="target-language"> {{ $t('translate') }} <img-->
                    <!--                            src="/assets/images/nav-arrow.svg" alt="translate-nav-arrow"></span>-->
                    <!--                    </div>-->

                </div>
                <!--                <div id="google_translate_element" style="display: none!important;">-->

                <!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Navigation",
    props: {
        activeTab: {
            type: String,
            default: 'Home'
        },
        topBarCategories: {
            type: Array,
            default: []
        },
        columns: {
            type: Object,
            default: []
        },

    }
}
</script>

<style scoped>
.translate-click {
    background-image: none !important;
}
</style>
